import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import useWindowDimensions from "@/lib/web-ui/useWindowDimensions";
import { BRAND_ABOUT_PAGE } from "@/settings/constant";
import { Stack, Typography, styled } from "@mui/material";
import { useRouter } from "next/router";
import { BrandAdBanner } from "./BrandAdBanner";
import { useBrandStore } from "./BrandProvider";
import { HomeContentsLayout } from "./HomeContentsLayout";
import BrandCategory from "./Products/Category/BrandCategory";
export const BrandHome = ()=>{
    const router = useRouter();
    const { name , introduction  } = useBrandStore((state)=>state.brand);
    const { isMobile , isTablet  } = useWindowDimensions();
    return /*#__PURE__*/ _jsxs(BrandHomeContainer, {
        children: [
            /*#__PURE__*/ _jsx(BrandAdBanner, {}),
            /*#__PURE__*/ _jsx(BrandCategory, {
                isStyledRadius: true
            }),
            /*#__PURE__*/ _jsx(HomeContentsLayout, {
                title: "브랜드 소개",
                onClick: ()=>{
                    //mx-28 전체보기 버튼 클릭시
                    mixpanelEvent("More Button Clicked", {
                        "Button Type": "브랜드 홈",
                        "Button Name": "전체보기",
                        "Button Url": BRAND_ABOUT_PAGE(name)
                    });
                    router.push(BRAND_ABOUT_PAGE(name));
                },
                children: /*#__PURE__*/ _jsx(Introduction, {
                    children: introduction
                })
            })
        ]
    });
};
const BrandHomeContainer = styled(Stack)((param)=>{
    let { theme  } = param;
    return {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: "40px",
        [theme.breakpoints.down("lg")]: {
            gap: "32px"
        },
        [theme.breakpoints.down("sm")]: {
            gap: "20px"
        }
    };
});
const Introduction = styled(Typography)((param)=>{
    let { theme  } = param;
    return {
        whiteSpace: "pre-line",
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "-webkit-box",
        WebkitLineClamp: 3,
        WebkitBoxOrient: "vertical",
        margin: "20px 0",
        color: theme.palette.text.secondary,
        ...theme.typography.body1
    };
});
